import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphQuote = ({ entity }) => {
  const quote = entity.getIn(['field_quote', 0, 'processed'], '');
  const author = entity.getIn(['field_author', 0, 'value']);

  return (
    <Container className="ParagraphQuote" small>
      <div className="row">
        <div className="col-12 col-md-12 ParagraphQuote__wrapper">
          <div>
            <div className="icon icon-quote icon-variant-2" />
          </div>
          <div>
            <WysiwygField
              property="schema:text"
              className="ParagraphQuote__quote"
              html={quote}
            />
            {author && (
              <div className="ParagraphQuote__author">- {author}</div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphQuote;
